<template>
  <div>
    <b-input-group class="autocomplete-input-group">
      <b-form-input
        id="input-vacancy"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        placeholder="Выберите вакансию"
        autocomplete="off"
        class="autocomplete-input-group"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button v-if="canCreateCatalog()" size="sm" variant="success" :disabled="isDisabled" @click="showModalCatalog">
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-vacancy" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>

    <Vacancy
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onVacancyCreated"
    />

  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Vacancy from "./Vacancy.vue";

export default {
  name: "VacancySelect",
  components: { Vacancy },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: Boolean,
    id: Number
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null,
      isModalVisible: false
    }
  },
  methods: {
    async configure(id) {
      this.query = "";

      if (id > 0) {
        const vacancy = (await this.getVacancyById(id)).data;
        if (vacancy != null) {
          this.query = vacancy.name;
          this.item = vacancy;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.item) {
        if (this.query !== this.item.name) {
          this.query = this.item.name;
        }
      } else {
        this.query = "";
      }
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect',null);
    },
    onClick(item) {
      this.query = item.name;
      this.item = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      const result = await this.getVacancySearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onVacancyCreated(newItem) {
      this.isModalVisible = false;
      this.onClick(newItem);
      this.items.push(newItem);
    },
    // Permissions
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_VACANCY_EDIT]);
    }
  },
  watch: {
    'query': {
      handler: async function (newVal) {
        if (this.item && newVal === this.item.name) return;

        if (newVal) {
          const lowerQuery = newVal.toLowerCase();
          this.items = await this.getItems(lowerQuery);
        }
      },
      deep: true
    },
    'id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.configure(newId);
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-vacancy {
  margin-top: 31px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1030;
  text-align: left;
}

.autocomplete-input-group {
  position: unset;
}

/* Autocomplete Select Input Group Item */
.autocomplete-vacancy .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/VacancySelect.vue